var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLogoutIcon = function SvgLogoutIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    style: {
      width: "inherit",
      height: "inherit"
    },
    viewBox: "0 0 25 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M8.75 9V5.25A2.25 2.25 0 0 1 11 3h6a2.25 2.25 0 0 1 2.25 2.25v13.5A2.25 2.25 0 0 1 17 21h-6a2.25 2.25 0 0 1-2.25-2.25V15m3.75-6 3 3m0 0-3 3m3-3H2.75"
  })));
};
export { SvgLogoutIcon as ReactComponent };
export default __webpack_public_path__ + "fa6931dbdc05f352823dad21f507d114.svg";